import { graphql } from '@tn/foundation/graphql/__generated/gql';

export const signUpCacheKey = 'signUp';
export const signUpDocument = /* GraphQL */ `
    mutation SignUp($formFields: SignUpFormFields!) {
        signUp(formFields: $formFields) {
            userId
            success
            message
            errors
        }
    }
`;
export const signUpMutation = graphql(signUpDocument);
